import { useState } from "react";

const VOICE_LABELS = { propia: "Tu voz", juanjo: "J. relatos" };
const VOICE_ORDER = ["propia", "juanjo"];

/**
 * Reproductor de audio con selector de voz para la web (poema a poema).
 * Muestra los botones de voz solo cuando hay 2 o más voces disponibles.
 */
export function VoiceAudioPlayer({ audios, audioUrl, idBase = "" }) {
  // Cache-busting: los MP3 de la voz propia se sustituyeron manteniendo el mismo nombre,
  // así que añadimos ?v=2 para forzar al navegador a descargar la versión nueva.
  const PROPIA_VERSION = "2";
  const bust = (url) => {
    if (!url) return url;
    return url + (url.includes("?") ? "&" : "?") + "v=" + PROPIA_VERSION;
  };

  const map = {};
  if (audios && typeof audios === "object") {
    Object.keys(audios).forEach((k) => {
      if (audios[k]) map[k] = k === "propia" ? bust(audios[k]) : audios[k];
    });
  }
  if (audioUrl && !map.propia) map.propia = bust(audioUrl);

  const keys = [
    ...VOICE_ORDER.filter((k) => map[k]),
    ...Object.keys(map).filter((k) => !VOICE_ORDER.includes(k)),
  ];

  const [selected, setSelected] = useState(keys[0]);

  if (keys.length === 0) return null;

  const effective = map[selected] ? selected : keys[0];
  const src = map[effective];

  return (
    <div data-testid={`voice-player-${idBase}`}>
      {keys.length >= 2 ? (
        <div
          className="flex flex-wrap items-center gap-2 mb-3"
          data-testid={`voice-selector-${idBase}`}
        >
          <span
            className="text-xs uppercase tracking-[0.25em] mr-1"
            style={{ color: "var(--rincon-text-muted)" }}
          >
            Voz:
          </span>
          {keys.map((k) => {
            const active = k === effective;
            return (
              <button
                key={k}
                type="button"
                onClick={() => setSelected(k)}
                data-testid={`voice-option-${k}-${idBase}`}
                aria-pressed={active}
                className="px-3 py-1 text-sm font-display border transition-colors"
                style={{
                  borderColor: "var(--rincon-primary)",
                  background: active ? "var(--rincon-primary)" : "transparent",
                  color: active ? "var(--rincon-bg)" : "var(--rincon-primary)",
                }}
              >
                {VOICE_LABELS[k] || k}
              </button>
            );
          })}
        </div>
      ) : null}
      <audio
        controls
        preload="none"
        src={src}
        key={src}
        className="w-full"
        data-testid={`audio-player-${idBase}`}
      >
        Tu navegador no soporta la reproducción de audio.
      </audio>
    </div>
  );
}
